<template>
    <div class="container">
        <h2 class="products-h2">Ok, we gaan aan de slag</h2>
        <p class="mb-5">Welk product had je graag laten zandstralen?</p>
        <div v-for="product in products" v-bind:key="product.id" class="product_item">
            <router-link :to="{ name: 'questions', params: { id: category_id, pid:product.id, 'product_name': product.name }}">
                {{ product.name }}
            </router-link>
        </div>
    </div>
</template>
<script>
    import ajax from '../ajax';

    export default {
        name: "Products",

        data() {
            return {
                category_id     : this.$route.params.id,
                products        : []
            }
        },

        mounted: function () {
            ajax
                .get(`/api/v1/category/${this.category_id}/products`)
                .then(response =>{
                    console.log(response.data.products);
                    if(response.status === 200) {
                        this.products = response.data
                    }
                })
                .catch(error =>{
                    console.log(error);
                })
        }
    }
</script>

<style scoped lang="scss">
    .products-h2 {
        font-size: 1.7rem;
        margin-bottom: 20px;
        text-align: center;
        font-weight: 500;
        @media (min-width: 992px) {
            font-size: 2rem;
            text-align: left;
        }
        @media (min-width: 1200px) {
            font-size: 2.4rem;
        }
    }

    .product_item a {
        background: transparent;
        padding: 20px 15px;
        border-radius: 0;
        border: 1px solid #FFFFFF;
        margin-bottom: 6px;
        color: white;
        display: block;
        text-decoration: none;
        transition: all .25s ease;
        &:hover{
            background-color: white;
            color: black;
        }
    }

</style>